import { render } from "./goods-item.vue?vue&type=template&id=61a8cefe&scoped=true&ts=true"
import script from "./goods-item.vue?vue&type=script&lang=tsx"
export * from "./goods-item.vue?vue&type=script&lang=tsx"

import "./goods-item.vue?vue&type=style&index=0&id=61a8cefe&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a8cefe"]])

export default __exports__